import { Dialog } from '@/components/_common';
import { DialogContentText } from '@mui/material';

type UnsavedChangesDialogProps = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const UnsavedChangesDialog = ({ isOpen, onCancel, onConfirm }: UnsavedChangesDialogProps) => {
  return (
    <Dialog open={isOpen} title="Do you want to continue?" submitText="Discard Changes" onCancel={onCancel} onSubmit={onConfirm}>
      <DialogContentText>You have unsaved changes. If you leave now, your changes will be lost.</DialogContentText>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
